module.exports = __webpack_public_path__ + "to.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/css/fonts/flag-icon-css/flags/4x3/to.svg
// module id = 849
// module chunks = 0